export default __webpack_public_path__ + "images/assets/211757658190687356df416b17ae4fb3.svg";